import { render, staticRenderFns } from "./ClashingRoomsDrillDown.vue?vue&type=template&id=85637d86&"
import script from "./ClashingRoomsDrillDown.vue?vue&type=script&lang=ts&"
export * from "./ClashingRoomsDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports